/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */

import * as React from "react";
import { addMonths, isSameDay, isAfter, isBefore, isSameMonth, addYears, max, min, isWithinInterval } from "date-fns";
import {
  addDays,
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfMonth,
  endOfMonth,
} from 'date-fns';
// eslint-disable-next-line no-unused-vars
import { DateRange, NavigationAction, DefinedRange } from "../types";
import { getValidatedMonths, parseOptionalDate } from "../utils";

import { defaultRanges } from "../defaults";

import Menu from "./Menu";

export const MARKERS = {
  FIRST_MONTH: Symbol("firstMonth"),
  SECOND_MONTH: Symbol("secondMonth"),
};

// interface DateRangePickerProps {
//   open: boolean;
//   initialDateRange?;
//   definedRanges?: DefinedRange[];
//   minDate? | string;
//   maxDate? | string;
//   onChange: (dateRange) => void;
// }

const DateRangePicker = (props) => {
  const today = new Date();

  const { open, onChange, initialDateRange, minDate, maxDate, definedRanges = defaultRanges } = props;

  const minDateValid = parseOptionalDate(minDate, addYears(today, -10));
  const maxDateValid = parseOptionalDate(maxDate, addYears(today, 10));
  const [intialFirstMonth, initialSecondMonth] = getValidatedMonths(initialDateRange || {}, minDateValid, maxDateValid);

  const [dateRange, setDateRange] = React.useState({ ...initialDateRange });
  const [hoverDay, setHoverDay] = React.useState();
  const [firstMonth, setFirstMonth] = React.useState(intialFirstMonth || today);
  const [secondMonth, setSecondMonth] = React.useState(initialSecondMonth || addMonths(firstMonth, 1));

  const { startDate, endDate } = dateRange;

  // handlers
  const setFirstMonthValidated = (date) => {
    if (isBefore(date, secondMonth)) {
      setFirstMonth(date);
    }
  };

  const setSecondMonthValidated = (date) => {
    if (isAfter(date, firstMonth)) {
      setSecondMonth(date);
    }
  };

  const setDateRangeValidated = (range) => {
    const date = new Date();
    let startDate = date,
      endDate = date;
    switch (range) {
      case "今日":
        startDate = date;
        endDate = date;
        break;
      case "昨日":
        startDate = addDays(date, -1);
        endDate = addDays(date, -1);
        break;
      case "本周":
        startDate = startOfWeek(date);
        endDate = endOfWeek(date);
        break;
      case "上周":
        startDate = startOfWeek(addWeeks(date, -1));
        endDate = endOfWeek(addWeeks(date, -1));
        break;
      case "近七天":
        startDate = addWeeks(date, -1);
        endDate = date;
        break;
      case "本月":
        startDate = startOfMonth(date);
        endDate = endOfMonth(date);
        break;
      case "上月":
        startDate = startOfMonth(addMonths(date, -1));
        endDate = endOfMonth(addMonths(date, -1));
        break;
    }
    setDateRange({ startDate, endDate });
    onChange({ startDate, endDate });
    // let { startDate: newStart, endDate: newEnd } = range;

    // if (newStart && newEnd) {
    //   range.startDate = newStart = max(newStart, minDateValid);
    //   range.endDate = newEnd = min(newEnd, maxDateValid);

    //   setDateRange(range);
    //   onChange(range);

    //   setFirstMonth(newStart);
    //   setSecondMonth(isSameMonth(newStart, newEnd) ? addMonths(newStart, 1) : newEnd);
    // } else {
    //   const emptyRange = {};

    //   setDateRange(emptyRange);
    //   onChange(emptyRange);

    //   setFirstMonth(today);
    //   setSecondMonth(addMonths(firstMonth, 1));
    // }
  };

  const onDayClick = (day) => {
    if (startDate && !endDate && !isBefore(day, startDate)) {
      const newRange = { startDate, endDate: day };
      onChange(newRange);
      setDateRange(newRange);
    } else {
      setDateRange({ startDate: day, endDate: undefined });
    }
    setHoverDay(day);
  };

  const onMonthNavigate = (marker, action) => {
    if (marker === MARKERS.FIRST_MONTH) {
      const firstNew = addMonths(firstMonth, action);
      if (isBefore(firstNew, secondMonth)) setFirstMonth(firstNew);
    } else {
      const secondNew = addMonths(secondMonth, action);
      if (isBefore(firstMonth, secondNew)) setSecondMonth(secondNew);
    }
  };

  const onDayHover = (date) => {
    if (startDate && !endDate) {
      if (!hoverDay || !isSameDay(date, hoverDay)) {
        setHoverDay(date);
      }
    }
  };

  // helpers
  const inHoverRange = (day) => startDate && !endDate && hoverDay && isAfter(hoverDay, startDate) && isWithinInterval(day, { start: startDate, end: hoverDay });

  const helpers = {
    inHoverRange,
  };

  const handlers = {
    onDayClick,
    onDayHover,
    onMonthNavigate,
  };

  return open ? <Menu dateRange={dateRange} minDate={minDateValid} maxDate={maxDateValid} ranges={definedRanges} firstMonth={firstMonth} secondMonth={secondMonth} setFirstMonth={setFirstMonthValidated} setSecondMonth={setSecondMonthValidated} setDateRange={setDateRangeValidated} helpers={helpers} handlers={handlers} /> : null;
};

export default DateRangePicker;
